import '@emotion/react'

// @endindex
import { ThemeBreakpoints } from './breakpoints'
import { ThemeColors } from './colors'
import { ThemeDropShadows } from './dropShadows'
import { ThemeMaxWidths } from './maxWidths'
import { ThemeMotion } from './motion'
import { ThemeSelectors } from './selectors'
import { ThemeSpacing } from './spacing'
import { ThemeTypography } from './typography'
import { ThemeWeights } from './weights'

// @index(['./*.{ts,tsx}', './*/index.{ts,tsx}'], f => `export {default as ${f.name}} from '${f.path.replace(/\/index$/, '')}'`)
export { default as breakpoints } from './breakpoints'
export {
  default as colors,
  getColorsByThemeVariant,
  palette,
  taxesColorsTheme,
  type Colors,
  type ThemeVariant,
} from './colors'
export { default as dropShadows } from './dropShadows'
export { default as maxWidths } from './maxWidths'
export { default as motion } from './motion'
export { default as selectors } from './selectors'
export { default as spacing } from './spacing'
export { default as typography } from './typography'
export { default as weights } from './weights'

export interface MooncakeTheme {
  pxToRem: (px: number) => string
  darkMode: boolean
  colors: ThemeColors
  maxWidths: ThemeMaxWidths
  motion: ThemeMotion
  typography: ThemeTypography
  weights: ThemeWeights
  breakpoints: ThemeBreakpoints
  dropShadows: ThemeDropShadows
  selectors: ThemeSelectors
  spacing: ThemeSpacing
}

declare module '@emotion/react' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface Theme extends MooncakeTheme {}
}
